<template>
  <v-layout
    justify-end
    wrap
    mt-3
  >
    <v-flex xs12>
      <h3 class="display-2">
        {{ previousEdition ? $t('alikes_families.p_e.question') : $t('alikes_families.question') }}
      </h3>
    </v-flex>
    <v-flex xs12>
      <v-radio-group
        ref="optionRadio"
        v-model="chosenOption"
        v-validate="validationRules.get('radio_buttons')"
        :error-messages="errors.collect('radio_buttons')"
        :data-vv-as="$t('alikes_families.question')"
        data-vv-name="radio_buttons"
        required
      >
        <v-radio
          :value="1"
          :label="radioLabels[0]"
          :ripple="false"
        />
        <v-divider class="mb-2" />
        <v-radio
          :value="2"
          :label="radioLabels[1]"
          :ripple="false"
        />
        <SimilarActionsChosenFamily
          :chosen-option="chosenOption"
          :previous-edition="previousEdition"
          @change="changeChosenFamily($event)"
        />
        <SimilarActionsOverwriteFamily
          v-if="showOverwriteFamilies"
          :chosen-option="chosenOption"
          :chosen-family="chosenFamily"
          @changeOverwriteFamily="changeOverwriteFamily($event)"
        />
        <v-divider class="mb-2" />
        <v-radio
          :value="3"
          :label="radioLabels[2]"
          :ripple="false"
        />
      </v-radio-group>
    </v-flex>
  </v-layout>
</template>

<script>
import SimilarActionsChosenFamily from '@/components/widgets/addFamily/familySimilar/SimilarActionsChosenFamily';
import SimilarActionsOverwriteFamily from '@/components/widgets/addFamily/familySimilar/SimilarActionsOverwriteFamily';
import validationRules from '@/constants/validationRules';

export default {
    name: 'SimilarActions',
    components: { SimilarActionsChosenFamily, SimilarActionsOverwriteFamily },
    inject: ['$validator'],
    props: {
        previousEdition: {
            default: false
        }
    },
    data: () => ({
        validationRules,
        chosenOption: null,
        chosenFamily: null,
        overwriteFamily: null
    }),
    computed: {
        similarFamilies () {
            return this.$store.getters['familyData/getSimilarFamilies'];
        },
        notAttributedFamilies () {
            return this.similarFamilies.filter(
                (el) => el.family_edition.primary_volunteer_assigned === false
            );
        },
        showOverwriteFamilies () {
            return (
                this.chosenOption === 2 &&
        this.chosenFamily === -1 &&
        this.notAttributedFamilies.length > 0 &&
        this.similarFamilies.length > 1
            );
        },
        radioLabels () {
            return [
                this.previousEdition
                    ? this.$t('alikes_families.p_e.actions.1')
                    : this.$t('alikes_families.actions.1'),
                this.previousEdition
                    ? this.$t('alikes_families.p_e.actions.2')
                    : this.$t('alikes_families.actions.2'),
                this.previousEdition
                    ? this.$t('alikes_families.p_e.actions.3')
                    : this.$t('alikes_families.actions.3')
            ];
        },
        chosenFamilyId () {
            if (this.chosenFamily != null && this.similarFamilies) {
                const family = this.similarFamilies[this.chosenFamily];
                return family.family_edition && family.family_edition.family_edition_id;
            }
            return null;
        }
    },
    watch: {
        chosenOption: {
            handler (val) {
                this.$emit('changeChosenOption', val);
            }
        },
        chosenFamily: {
            handler (val) {
                if (val === -1 && this.similarFamilies.length === 1) {
                    this.overwriteFamily = this.similarFamilies[0].family_edition.family_edition_id;
                    this.$emit('changeOverwriteFamily', this.overwriteFamily);
                }
            }
        },
        similarFamilies: {
            handler (val) {
                this.chosenOption = null;
                this.$validator.reset();
            }
        }
    },
    methods: {
        changeChosenFamily ($event) {
            this.chosenFamily = $event;
            if (this.previousEdition) {
                this.$emit('changeChosenFamily', this.chosenFamilyId);
            } else {
                this.$emit('changeChosenFamily', $event);
            }
        },
        changeOverwriteFamily ($event) {
            this.overwriteFamily = $event;
            this.$emit('changeOverwriteFamily', $event);
        }
    }
};
</script>

<style scoped></style>
